/** COLLECTION CAROUSEL **/

$(document).ready(function() {

  $('.product-buy-buttons--cta').on("click", function() {
    $("div[aria-label='close']").trigger("click");
  });
  

 /* $('.owl-carousel').owlCarousel({
      loop:true,
      margin:20,
      nav:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:3
          },
          1000:{
              items:4
          }
      }
  });*/
  
  
  $('.search--root').parent().addClass('search');


  
});


/** LOGO **/


  

  $(document).ready(function() {

    //initial load 
	$('.template--index .header--logo img').attr('src', 'https://cdn.shopify.com/s/files/1/0627/1146/4171/files/Little-Trouble.gif?v=1650901901'); 

    setTimeout(
      function() 
      {
        $('.template--index .header--logo img').attr('src', 'https://cdn.shopify.com/s/files/1/0627/1146/4171/files/Little-Trouble.png?v=1650901749');
      }, 2000);
    
    // mouseovers

    $('.header--logo img').mouseover(function() {
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0627/1146/4171/files/Little-Trouble.gif?v=1650901901');
    });

    $('.header--logo img').mouseleave(function() {
      $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0627/1146/4171/files/Little-Trouble.png?v=1650901749');
    });
  });



/** RANDOM CLASSES 

jQuery(document).ready(function(){
    moveTheBoxes();
});
function moveTheBoxes() {
  var classes = [ 'position-1', 'position-2', 'position-3', 'position-4'];
        jQuery('body').each(function(){
        jQuery(this).addClass(classes[~~(Math.random()*classes.length)]);
    });
    setTimeout(animateTheBoxes, 5000);
}**/

/** CTA BUTTON **/

$(document).ready(function() {
    $(".product-buy-buttons--cta").on( "click", function() {
        $('span.product-buy-buttons--cta-text').html('<span class="product-buy-buttons--cta-text"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg><span class="dope">dope!</span><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><g clip-path="url(#clip0_112_526)"><path d="M2.17709 1.06389C3.29896 -0.0286104 5.46257 -0.343353 6.24254 0.416198C7.0225 1.17575 5.32367 3.34255 5.97542 3.97985C6.62718 4.61714 8.99646 3.2515 9.55739 4.58592C10.1183 5.92034 4.73336 16 3.61149 16C2.48962 16 4.04688 10.7196 3.29896 9.98862C2.55105 9.25768 1.11666 11.0291 0.243204 10.1707C-0.630251 9.31231 1.05522 2.159 2.17709 1.06389Z" fill="#FEFAF3"></path></g><defs><clipPath id="clip0_112_526"><rect width="9.6" height="16" fill="white"></rect></clipPath></defs></svg></span>')
    });
  
  
  $('p').each(function() {
    const $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
        $this.remove();
  });
  
/** HIGLIGHTED CURRENT RELATED VARIANT **/

  setTimeout(function() {
     $('.related-variant-swap span:contains("'+$('.product-page--overline').text().trim().split('- ')[1]+'")').parent().parent().addClass('currentVariant');
  }, 100);
});

/** INDEX SVG ENTRANCE **/


$(document).ready(function() {
  
  scrollOffset = 200;

$(window).scroll(function() {
  
  $('.template--index .hero-block-v2 svg').each(function() {
      if ($(window).scrollTop()+$(window).height() >= $(this).position().top && $(window).scrollTop() < $(this).position().top + $(this).height()) {
        
        if (!$('.template--index .hero-block-v2 svg').hasClass('entrance')){
            console.log('success');
          $('.template--index .hero-block-v2 svg').attr("class", "entrance");
        }
      }
    });
  });
  
});

/** HIDE REVIEW STARS IF EMPTY **/

setTimeout(function() {
   $('span.junip-product-summary:empty').parents('.product-page--block').addClass('hide');
}, 800);


/** STYLE COVET IG WIDGET **/

setTimeout(function() {
   $('.grid-item').css('border','1px solid red');
}, 2000);


// Mega menu
const megaMenu = () => {
  const levelOneLink = document.querySelectorAll('.x-menu--level-1--link');
  levelOneLink.forEach(item => {
    const dataMenuDepth = item.getAttribute('data-x-menu--depth');
    if(dataMenuDepth > 2) {
      item.classList.add('mega-menu')
    }
  })
  
}
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.header--root')) {
    megaMenu();
  }
});

if(typeof Shopify !== 'undefined') {
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      megaMenu();
    });
  }
}

// Mobile menu
const mobileMenu = () => {
  const mobileNavLevel1 = document.querySelectorAll('.mobile-item--level-1__has-items');
  if(mobileNavLevel1.length > 0) {
    mobileNavLevel1.forEach(item => {
      const dropdown = item.querySelector('.mobile-item__dropdown');
      const level2 = item.querySelector('.mobile-menu__level-2');
      const chevron = item.querySelector('.mobile-item__toggle');

      dropdown.addEventListener('click', (e) => {
        e.preventDefault();
        level2.classList.toggle('is-expanded');
        chevron.classList.toggle('is-expanded');
      })
    })
  }
}
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.mobile-nav')) {
    mobileMenu();
  }
}); 